import { defineComponent } from "vue";
import PtSelect from "./index.vue";
import PtOption from "./pt-option.vue";
import PtOptionGroup from "./pt-option-group.vue";
import { selectGroupProProps } from "./props";
export default defineComponent({
    name: "PtSelectGroupPro",
    components: {
        PtSelect: PtSelect,
        PtOption: PtOption,
        PtOptionGroup: PtOptionGroup
    },
    props: selectGroupProProps
});
